var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgErrorOrder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 16,
    viewBox: "0 0 15 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.49996 0.916687C11.4121 0.916687 14.5833 4.08861 14.5833 8.00003C14.5833 11.9114 11.4121 15.0834 7.49996 15.0834C3.58784 15.0834 0.416626 11.9114 0.416626 8.00003C0.416626 4.08861 3.58784 0.916687 7.49996 0.916687ZM7.49996 2.09748C4.24517 2.09748 1.59742 4.74523 1.59742 8.00003C1.59742 11.2548 4.24517 13.9026 7.49996 13.9026C10.7548 13.9026 13.4025 11.2548 13.4025 8.00003C13.4025 4.74523 10.7548 2.09748 7.49996 2.09748ZM7.49904 9.77242C7.88969 9.77242 8.20639 10.0892 8.20639 10.4798C8.20639 10.8705 7.88969 11.1872 7.49904 11.1872C7.10833 11.1872 6.79163 10.8705 6.79163 10.4798C6.79163 10.0892 7.10833 9.77242 7.49904 9.77242ZM7.49607 4.45836C7.76502 4.45814 7.98744 4.65782 8.02279 4.9171L8.02774 4.98918L8.03029 8.17782C8.03051 8.47121 7.79286 8.70928 7.49947 8.70949C7.23051 8.70971 7.00803 8.51003 6.97268 8.25078L6.96779 8.17867L6.96524 4.99003C6.96496 4.69663 7.20261 4.45859 7.49607 4.45836Z",
    fill: "#FF6262"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgErrorOrder);
export default __webpack_public_path__ + "static/media/error_order.3221f2c99596d29e6558d0f36acbc062.svg";
export { ForwardRef as ReactComponent };